import { Link, useParams } from "react-router-dom";
import { useApi } from "../lib/api";
import { useSeo, breadcrumbLd } from "../lib/seo";
import { PageHero, EmptyState, Crumbs } from "../components/shop/Common";
import { ProductListing } from "../components/shop/ProductListing";
import NotFoundBlock from "./NotFoundBlock";

const EMPTY_TEXT = {
  "best-sellers": "Best sellers are ranked by real orders — this list will fill in once customers start shopping.",
  "new-arrivals": "New designs are dropping soon.",
};

export default function CollectionPage() {
  const { slug } = useParams();
  const { data, loading, error } = useApi(`/collections/${slug}`);
  const c = data?.collection;
  useSeo({
    title: c?.name,
    description: c?.description,
    jsonLd: c && { "@context": "https://schema.org", ...breadcrumbLd([["Home", "/"], [c.name, `/collections/${slug}`]]) },
  });
  if (error) return <NotFoundBlock />;
  return (
    <>
      <PageHero eyebrow="Collection" title={c?.name || "\u00a0"} subtitle={c?.subtitle} />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <Crumbs items={[["Home", "/"], ["Shop", "/shop"], [c?.name || "Collection"]]} />
        <ProductListing
          key={slug}
          products={data?.products}
          loading={loading}
          empty={
            <EmptyState title="Nothing here yet" text={EMPTY_TEXT[slug] || "We're designing this collection now. Check back soon!"} testid="collection-empty">
              <Link to="/destinations" className="rounded-full bg-sun px-6 py-3 font-bold text-navy">Shop by destination</Link>
            </EmptyState>
          }
        />
      </section>
    </>
  );
}
